// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledIcon } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { featuredCategoriesStyles } from "@turnerBlueprint/App/Widgets/FeaturedCategories/FeaturedCategories";
import IconArrowRight from "@turnerBlueprint/XDL/Icons/IconArrowRight";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, ellipsis } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

featuredCategoriesStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
featuredCategoriesStyles.titleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        padding: 13px;
        border: 1px solid ${color("common.border")};
        background: ${color("common.ui11")};
    `,
};

featuredCategoriesStyles.title = {
    variant: "h3",
    forwardAs: "h2",
    color: "common.white",
    css: css`
        margin: 0;
    `,
};

featuredCategoriesStyles.link = {
    mergeCss: true,
    typographyProps: {
        size: 15,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 18px;
        `,
    },
    icon: {
        iconProps: {
            color: "common.white",
            size: 12,
            src: IconArrowRight,
            css: css`
                width: 6px;
                margin-left: 8px;
                opacity: 0.66;
            `,
        },
        position: "right",
    },
    color: "common.white",
    css: css`
        &:not(:disabled):visited {
            color: ${color("common.white")};
            ${TypographyStyle}, ${StyledIcon} {
                color: ${color("common.white")};
            }
        }
        width: fit-content;
    `,
};

featuredCategoriesStyles.centeringWrapper = {
    css: css`
        display: flex;
        height: 100px;
        justify-content: center;
        align-items: center;
    `,
};

featuredCategoriesStyles.box = {
    gap: 0,
    offsetCss: css`
        border: 1px solid ${color("common.border")};
    `,
};
featuredCategoriesStyles.cardContainer = {
    width: 6,
    css: css`
        gap: 12px;
        padding: 13px;
        padding-bottom: 17px;
        height: 170px;
        background-color: ${color("common.ui1")};
        &:first-child {
            border-right: 1px solid ${color("common.border")};
            border-bottom: 1px solid ${color("common.border")};
        }
        &:nth-child(2) {
            border-bottom: 1px solid ${color("common.border")};
        }
        &:nth-child(3) {
            border-right: 1px solid ${color("common.border")};
        }
    `,
};

featuredCategoriesStyles.cardContainerLink = {
    css: css`
        width: 100%;
        height: 100%;
    `,
    typographyProps: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
            gap: 12px;
        `,
    },
};
featuredCategoriesStyles.subtitle = {
    variant: "h6",
    forwardAs: "h3",
    color: "text",
    css: css`
        text-align: center;
        ${ellipsis(2)}
        margin-bottom: 0;
        width: 100%;

        &:hover {
            color: ${color("common.ui9")};
        }
    `,
};
